import storage from 'redux-persist/es/storage';
// import storageSession  from 'redux-persist/lib/storage/session'; // Not needed anymore
import { persistCombineReducers } from 'redux-persist'
import { authenticateReducer } from './authenticateReducer'
import { invoiceDateReducer, invoiceSearchReducer, invoiceMonthYearsReducer } from './invoiceDateReducer'
import { invoiceListReducer } from './invoiceListReducer';
import { invoiceViewReducer } from './invoiceViewReducer';
import  vendorReportReducer  from './vendorReportReducer';
import { setNotificationRefReducer } from './setNotificationRefReducer'
import { pendingTasksReducer } from 'react-redux-spinner';
import vendorReportSPDReducer from './vendorReportSPDReducer';
export default persistCombineReducers({ key: 'root', storage: storage, blacklist: ['refNotify', 'invSearchRes', 'pendingTasks'] }, {
  authInfo: authenticateReducer,
  invoiceList: invoiceListReducer,
  invoiceSelectedDate: invoiceDateReducer,
  invoiceView: invoiceViewReducer,
  pendingTasks: pendingTasksReducer,
  refNotify: setNotificationRefReducer,
  invSearchRes: invoiceSearchReducer,
  invoiceMonthYears: invoiceMonthYearsReducer,
  vendorspReport:vendorReportReducer,
  vendorspReportSPD: vendorReportSPDReducer
  // cart
});
